import analytics from '~/assets/util/analytics'

export default {
	name: 'VidswapMixin',
	props: {
		team: {
			type: Object,
			required: true
		},
		isMonthlySubscription: {
			type: Boolean,
			required: false,
			default: false
		}
	},
	data: () => ({ vsLoading: false, vsData: { authLink: null, status: 'new' } }),
	computed: {
		vsStateTitle () {
			// status: new, pending, active
			return this.vsData.status === 'active'
				? this.$tc('components.vidswap.enterAccountText')
				: this.isMonthlySubscription
					? this.$tc('components.vidswap.requestMonthlyAccountText')
					: this.$tc('components.vidswap.requestAccountText')
		},
		isVSAvailable () {
			const canSignUp = this.vsData.status === 'new' && !this.team.custom?.vsActive
			const canLogIn = this.vsData.status === 'active'

			return canSignUp || canLogIn
		}
	},
	methods: {
		trackVidSwapTrigger (trigger) {
			this.$store.dispatch('analytics/track', {
				event: analytics.VidSwapUpsellTriggerClicked.event,
				data: analytics.VidSwapUpsellTriggerClicked.getData({
					trigger,
					source: 'vidswap_block',
					team: this.team
				})
			})
		},
		async getVSLink () {
			this.vsLoading = true

			try {
				const user = this.$store.getters['user/user']
				const payload = {
					clubId: this.team.id,
					callbackUrl: `${window.location.origin}/my/profile/teams/edit/?id=${this.team.id}&vsActive=true`,
					metadata: {
						clubName: user.clubName,
						teamName: this.team.name,
						teamSport: this.team.sportType,
						city: user?.address?.city,
						state: user?.address?.state,
						country: user?.address?.country,
						email: user.email,
						firstName: user.firstName,
						lastName: user.lastName,
						phoneNumber: user.phone
					}
				}

				this.vsData = await this.$axios.$post('/gw/vidswap/login', payload)
			} catch (error) {
				this.$log.error('Failed to load vidswap auth data', error)
			}

			this.vsLoading = false
		},

		async loginVS () {
			this.vsLoading = true
			if (this.vsData.status === 'new') {
				this.trackVidSwapTrigger('Request an account')
			}

			if (this.isVSAvailable && this.vsData.authLink) {
				window.open(this.vsData.authLink, '_self')
			} else {
				await this.getVSLink()

				if (this.isVSAvailable) {
					window.open(this.vsData.authLink, '_self')
				} else {
					this.$toast.error('Your request has already been submitted')
				}
			}

			this.vsLoading = false
		}
	}
}
